import { render, staticRenderFns } from "./inspectionTasks.vue?vue&type=template&id=01118253&scoped=true"
import script from "./inspectionTasks.vue?vue&type=script&lang=js"
export * from "./inspectionTasks.vue?vue&type=script&lang=js"
import style0 from "./inspectionTasks.vue?vue&type=style&index=0&id=01118253&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01118253",
  null
  
)

export default component.exports